"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatSelectionPopup = exports.SeatSelection = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const AircraftSeatsPlan_1 = require("../../../AircraftSeatsPlan");
const Remove_1 = require("../../../Button/Remove");
const Sub_1 = require("../../../Page/Title/Sub");
const PopupWrapper_1 = require("../../../Popup/PopupWrapper");
require("./index.scss");
const className = 'seat-selection-popup';
const SeatSelection = (props) => {
    var _a;
    const { modificators, sections, tariffGroupCode, selectSeat, resetSeat, selectedPassengerId, passengers, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    const selectedSeats = passengers
        .map(passengerWithSeat => passengerWithSeat.seatLabel)
        .filter((value) => !!value);
    const activeSeats = passengers
        .filter(passengerWithSeat => passengerWithSeat.id === selectedPassengerId)
        .map(passengerWithSeat => passengerWithSeat.seatLabel)
        .filter((value) => !!value);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(Sub_1.PageSubTitle, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Seat/AircraftSeatsSelection/Popup/SeatSelectionPopup:Title', defaultMessage: 'Seat selection' }) }),
        react_1.default.createElement(Remove_1.RemoveButton, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Seat/AircraftSeatsSelection/Popup/SeatSelectionPopup:RemoveSeat', defaultMessage: 'Remove seat' }), onClick: () => resetSeat(), hidden: !((_a = passengers.find(x => x.id === selectedPassengerId)) === null || _a === void 0 ? void 0 : _a.seatLabel) }),
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("div", { className: `${className}__body` },
                react_1.default.createElement(AircraftSeatsPlan_1.AircraftSeatsPlan, { onSeatClick: selectSeat, sections: sections, selectedSeats: selectedSeats, activeSeats: activeSeats, modificators: ['mobile'], tariffGroupCode: tariffGroupCode })))));
};
exports.SeatSelection = SeatSelection;
const SeatSelectionPopup = (props) => {
    const { close, ...restProps } = props;
    return (react_1.default.createElement(PopupWrapper_1.PopupWrapper, { isOpened: true, onClose: close, isCloseButtonVisible: true, modificators: ['lg'] },
        react_1.default.createElement(exports.SeatSelection, { ...restProps })));
};
exports.SeatSelectionPopup = SeatSelectionPopup;
//# sourceMappingURL=index.js.map